export default {
	messages: {
		de: {
			companyData: 'Firmendaten',
			display: 'Anzeige',
		},
		en: {
			companyData: 'Company Data',
			display: 'Display',
		},
	},
};
